import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';

import Loading from 'flow/components/ui-components/Loading';
import { ExtensionKey } from 'flow/types/EntityKeys';

import useProfiles from 'flow/hooks/useProfiles';
import useExtension from 'flow/hooks/useExtension';
import CalendarBase from '../calendar/CalendarBase';
import {
    getCalendar,
    updateOpeningHours,
} from 'flow/actions/extension-actions';
import { selectExtensionActiveProfile } from 'flow/selectors/ExtensionSelectors';
import { getCalendarWithActiveProfileAddedToEvents } from 'flow/utils/calendar-utils';
import {
    clearCalendarEvents,
    updateCalendar,
} from 'flow/actions/profile-actions';
import useSinglePaneMode from 'flow/hooks/useSinglePaneMode';
import useSettingsNavigation from 'flow/hooks/useSettingsNavigation';

const WorkHours = () => {
    const dispatch = useAppDispatch();
    const { goToSettings } = useSettingsNavigation();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const { extension } = useExtension(extensionKey);
    const { isSinglePaneMode } = useSinglePaneMode();

    const { activeProfiles } = useProfiles(extensionKey);

    const calendar = extension.get('calendar');

    const activeProfile = useAppSelector((state) =>
        selectExtensionActiveProfile(state, extensionKey),
    );

    const updatedCalendar = calendar
        ? getCalendarWithActiveProfileAddedToEvents(activeProfile, calendar)
        : null;

    useEffect(() => {
        dispatch(getCalendar(extensionKey));
    }, [extensionKey]);

    if (!calendar) {
        return <Loading signalFinishedLoading={true} />;
    }

    return (
        <CalendarBase
            calendar={updatedCalendar}
            entityKey={extensionKey}
            profiles={activeProfiles}
            showExternallyManagedInfo={true}
            updateOpeningHours={(openingHours) => {
                dispatch(updateOpeningHours(extensionKey, openingHours));
            }}
            clearCalendar={() => {
                dispatch(clearCalendarEvents(extensionKey));
            }}
            updateCalendar={(updatedCalendar) => {
                dispatch(updateCalendar(extensionKey, updatedCalendar));
            }}
            onClickBack={isSinglePaneMode ? goToSettings : undefined}
        />
    );
};

export default WorkHours;
